import { render, staticRenderFns } from "./ConversationSnapshot.vue?vue&type=template&id=282ef7fb&"
import script from "./ConversationSnapshot.vue?vue&type=script&lang=js&"
export * from "./ConversationSnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports